import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import SectionHead from "../components/site/SectionHead";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [category, setCategory] = useState("");
  const categories = [...new Set(posts.map((p) => p.category))];

  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data)).catch(() => {});
  }, []);

  const filtered = category ? posts.filter((p) => p.category === category) : posts;

  return (
    <div data-testid="blog-page" className="container-site py-14 lg:py-20">
      <SectionHead eyebrow="Financial Education" title="Learn Before You Borrow"
        subtitle="Plain-language guides on loans, credit scores, EMIs and financial awareness from the BharatBest editorial desk." />
      <div className="flex flex-wrap gap-2.5 mt-10">
        <button onClick={() => setCategory("")} data-testid="blog-filter-all"
          className={`rounded-full px-4 py-2 text-xs font-bold border transition-colors duration-200 ${!category ? "bg-brand-dark text-white border-brand-dark" : "bg-white border-black/10 text-brand-muted hover:border-black/30"}`}>All</button>
        {categories.map((c) => (
          <button key={c} onClick={() => setCategory(c)} data-testid={`blog-filter-${c.toLowerCase().replace(/\s+/g, "-")}`}
            className={`rounded-full px-4 py-2 text-xs font-bold border transition-colors duration-200 ${category === c ? "bg-brand-dark text-white border-brand-dark" : "bg-white border-black/10 text-brand-muted hover:border-black/30"}`}>{c}</button>
        ))}
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-10">
        {filtered.map((b) => (
          <Link key={b.id} to={`/blog/${b.slug}`} data-testid={`blog-card-${b.slug}`} className="card-site group overflow-hidden flex flex-col">
            <div className="h-48 overflow-hidden">
              <img src={b.image} alt={b.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
            </div>
            <div className="p-6 flex flex-col flex-1">
              <span className="text-[10px] uppercase tracking-[0.18em] font-bold text-brand-red">{b.category}</span>
              <h2 className="mt-2 font-heading text-lg font-bold text-brand-dark leading-snug flex-1">{b.title}</h2>
              <p className="mt-3 text-sm text-brand-muted leading-relaxed line-clamp-2">{b.excerpt}</p>
              <p className="mt-4 text-xs text-brand-muted font-semibold">{b.read_time} · {b.author}</p>
            </div>
          </Link>
        ))}
      </div>
      {filtered.length === 0 && <p className="mt-10 text-center text-brand-muted text-sm">No articles in this category yet.</p>}
    </div>
  );
}
